// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"509":"2eb84dcc","780":"2eb84dcc","791":"2eb84dcc"}[chunkId] + ".chunk.css";
};